import { H4 } from "../../../../../AbstractElements";
import { InvoiceFourData } from "../../../../../Data/Applications/ECommerce/ECommerce";

const InvoiceTableBody = () => {
  return (
    <tbody className="invoice-4">
      {InvoiceFourData.map((data, i) => (
        <tr key={i}>
          <td style={{ padding: 30 }}>
            <H4 style={{ fontWeight: 600, margin: "4px 0px", fontSize: 18, color: "#1a5f7f" }}>{data.title}</H4>
            <span style={{ opacity: "0.8", fontSize: 16 }}>{data.detail}</span>
          </td>
          <td style={{ width: "12%", textAlign: "center" }}>
            <span style={{ opacity: "0.8" }}>
              {`$`}
              {data.price}.00
            </span>
          </td>
          <td style={{ width: "12%", textAlign: "center" }}>
            <span style={{ opacity: "0.8" }}>{data.quantity}</span>
          </td>
          <td style={{ width: "12%", textAlign: "center" }}>
            <span style={{ color: "#1a5f7f", fontWeight: 600, opacity: "0.9" }}>
              {`$`}
              {data.total}.00
            </span>
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default InvoiceTableBody;
